import { createContext, useContext } from 'react';

import {
  IWebchatIdentity,
  TWebchatWidgetStatus,
} from 'modules/webchat/domain/entities';

export interface IWebchatContextData {
  /** Existe canal Webchat configurado para a tenância atual. */
  isEnabled: boolean;
  /**
   * O chat pode aparecer agora: configurado, navegador que não é bot e rota
   * fora de WEBCHAT_BLOCKED_ROUTES.
   */
  isAvailable: boolean;
  /**
   * Identidade com que o widget é (ou será) montado. O cliente logado é
   * identificado pela sessão; o visitante só depois do mountWebchat.
   */
  identity: IWebchatIdentity | null;
  /**
   * Situação do widget nesta carga da página: idle (não montado), loading
   * (carregando), ready (launcher da Callbell na tela) ou failed (não vai
   * aparecer; o site volta ao WhatsApp flutuante).
   */
  status: TWebchatWidgetStatus;
  /**
   * Há um botão de chat flutuante no canto inferior direito (o nosso ou o da
   * Callbell). Elementos fixos nesse canto devem se afastar dele com
   * clearWebchatLauncher.
   */
  isLauncherVisible: boolean;
  /**
   * Monta o widget para um visitante já identificado (pré-chat). A
   * identidade fica salva no navegador até o próximo login ou logout. Com
   * cliente logado, ou com identidade fora do formato do pré-chat
   * (parseVisitorWebchatIdentity), a chamada é ignorada.
   */
  mountWebchat(identity: IWebchatIdentity): void;
  /**
   * Abre a janela do chat, esperando o widget carregar. Resolve false quando
   * não deu; se o widget falhou, avisa a pessoa com um toast.
   */
  openWebchat(): Promise<boolean>;
}

export const WebchatContext = createContext<IWebchatContextData>({
  isEnabled: false,
  isAvailable: false,
  identity: null,
  status: 'idle',
  isLauncherVisible: false,
  mountWebchat: () => undefined,
  openWebchat: () => Promise.resolve(false),
});

export const useWebchat = () => useContext(WebchatContext);
